<div class="reminderModal__deleteOptions">
  <div class="reminderModal__cancelConfirmTextContainer">
    <p class="reminderModal__confirmCancelHeader">
      {{ 'delete_reminder_series_modal_text' | ppTranslate }}
    </p>
  </div>

  <div class="deleteReminderRadios">
    <span
      class="deleteReminderRadio"
      ppTooltip
      [ppTitle]="ppCreatedForMe() ? ('reminder_created_for_me_delete_warning' | ppTranslate) : ''"
      [class.deleteReminderRadio--disabled]="ppCreatedForMe()"
      (click)="selectOption(EEditReminderOptions.SINGLE)"
    >
      <pp-radio
        [ppChecked]="ppReminderDeleteOption() === EEditReminderOptions.SINGLE"
        [ppDisabled]="ppCreatedForMe()"
      >
      </pp-radio>
      {{ 'edit_single_reminder' | ppTranslate }}
    </span>

    <span
      class="deleteReminderRadio"
      ppTooltip
      [ppTitle]="ppCreatedForMe() ? ('reminder_created_for_me_delete_warning' | ppTranslate) : ''"
      [class.deleteReminderRadio--disabled]="ppCreatedForMe()"
      (click)="selectOption(EEditReminderOptions.THIS_AND_FUTURE)"
    >
      <pp-radio
        [ppChecked]="ppReminderDeleteOption() === EEditReminderOptions.THIS_AND_FUTURE"
        [ppDisabled]="ppCreatedForMe()"
      >
      </pp-radio>
      {{ 'edit_reminder_series' | ppTranslate }}
    </span>

    <span class="deleteReminderRadio" (click)="selectOption(EEditReminderOptions.SERIES)">
      <pp-radio [ppChecked]="ppReminderDeleteOption() === EEditReminderOptions.SERIES"> </pp-radio>
      {{ 'all_reminders_in_series' | ppTranslate }}
    </span>
  </div>
</div>

<div class="reminderModal__actionButtonsRow reminderModal__actionButtonsPositioning">
  <pp-button
    class="reminderModal__actionButton"
    data-test="cancelReminderButton"
    ppStyle="secondary"
    ppSize="wide"
    (ppAction)="cancel()"
    >{{ 'cancel' | ppTranslate }}</pp-button
  >
  <pp-button
    data-test="setReminderButton"
    class="reminderModal__actionButton"
    (ppAction)="delete()"
    ppStyle="primary"
    ppSize="wide"
    [ppWarning]="true"
    >{{ 'Delete' | ppTranslate }}</pp-button
  >
</div>
